import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { RestorableNote } from '@teetsh/app/src/containers/Dashboard/Todolist/types';

export const NOTES_TRASH_KEY = 'notes_trash';

function fetchNotesTrash() {
  const requestURL = '/notes/trash';
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }: { data: RestorableNote[] }) => data || []);
}

export function useNotesTrash() {
  return useQuery({
    queryKey: [NOTES_TRASH_KEY],
    queryFn: () => fetchNotesTrash(),
    placeholderData: [],
    refetchOnWindowFocus: false,
  });
}
